import { useCallback, useState } from 'react';
import {
	StyledHorizontalContainer,
	StyledVerticalContainer,
} from '../Container';
import {
	StyledSwitch,
	StyledSwitchDot,
	StyledText,
} from './ToggleBlock.styled';

export interface IToggleBlockProps {
	title: string;
	onChange?: (newValue: boolean) => void;
}

const ToggleBlock: React.FC<IToggleBlockProps> = ({ title, onChange }) => {
	const [isChecked, setIsChecked] = useState(false);

	const handleToggleChecked = useCallback(() => {
		onChange?.(!isChecked);
		setIsChecked(!isChecked);
	}, [isChecked, onChange]);

	return (
		<StyledVerticalContainer>
			<StyledHorizontalContainer>
				<StyledText>{title}</StyledText>
				<StyledSwitch onClick={handleToggleChecked}>
					<StyledSwitchDot $checked={isChecked} />
				</StyledSwitch>
			</StyledHorizontalContainer>
		</StyledVerticalContainer>
	);
};

export { ToggleBlock };
